module.exports = __webpack_public_path__ + "static/media/cannabis.34960575.png";